export enum ValueField {
  UNIT_ASSIST = 'unitAssist',
  UNIT_VALUE = 'unitValue',
  TOTAL_ASSIST = 'totalAssist',
  TOTAL_VALUE = 'totalValue',
}
